import { Box, Collapse, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import UserCard from './UserCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import CreateModal from './CreateModal';

const data: IUser[] = [
    {
      id: 1,
      email: 'alice.admin@example.com',
      roles: 'admin',
      password: 'hashed_password_admin',
      isRegistered: true,
      name: 'ישראל ישראלי',
      phone: '053-2717339',
      extId: 'admin-001',
      isBlocked: false,
      createdAt: '2025-01-01T08:30:00Z',
      recovery: '',
      updatedAt: '2025-04-15T10:00:00Z',
      attempts: 0,
      blockedAttemptsAt: '',
      company: 'AdminCorp',
      avatar: null,
      areaPermissions: [],
      permission: {
        id: 1,
        isEditable: true,
        title: 'בעלים',
        color: '#FF326F',
        permissionDetaileds: [
          {
            id: 11,
            isArchitecture: true,
            isOrderable: true,
            isOrderEditable: true,
            isServiceable: true,
            isServiceEditable: true,
            isOrdersView: true,
            isServiceView: true,
            isDeliveryView: true,
            isAccounting: true,
          },
        ],
      },
      isOwner: true,
      isPayCustomer: false,
      isNotPayedCustomer: false,
      isRegularCustomer: false,
      userFreeFields: [
        { id: 1, keyword: 'department', valueword: 'IT' },
      ],
      minimumOrder: 0,
      isSendOrderDoc: false,
    },
    {
      id: 2,
      email: 'Yaakovmorag2024@Companyname.com',
      roles: 'manager',
      password: 'hashed_password_manager',
      isRegistered: true,
      name: 'יעקוב מורג',
      phone: '053-2717339',
      extId: 'mgr-002',
      isBlocked: false,
      createdAt: '2025-02-10T09:15:00Z',
      recovery: '',
      updatedAt: '2025-04-10T11:30:00Z',
      attempts: 1,
      blockedAttemptsAt: '',
      company: 'ManageIt',
      avatar: null,
      areaPermissions: [],
      permission: {
        id: 2,
        isEditable: false,
        title: 'מנהל סניף',
        color: '#418CDD',
        permissionDetaileds: [
          {
            id: 21,
            isArchitecture: false,
            isOrderable: true,
            isOrderEditable: false,
            isServiceable: true,
            isServiceEditable: false,
            isOrdersView: true,
            isServiceView: true,
            isDeliveryView: false,
            isAccounting: false,
          },
          {
            id: 22,
            isArchitecture: false,
            isOrderable: false,
            isOrderEditable: false,
            isServiceable: false,
            isServiceEditable: false,
            isOrdersView: false,
            isServiceView: false,
            isDeliveryView: false,
            isAccounting: false,
          },
        ],
      },
      isOwner: false,
      isPayCustomer: false,
      isNotPayedCustomer: false,
      isRegularCustomer: true,
      userFreeFields: [],
      minimumOrder: 50,
      isSendOrderDoc: true,
    },
    {
      id: 3,
      email: 'SabrinaKirklevich@companyname.com',
      roles: 'customer',
      password: 'hashed_password_customer',
      isRegistered: true,
      name: 'סברינה קירקלביץ׳',
      phone: '053-2717339',
      extId: 'cust-003',
      isBlocked: false,
      createdAt: '2025-03-05T14:45:00Z',
      recovery: 'recovery-token-003',
      updatedAt: '2025-04-20T08:00:00Z',
      attempts: 2,
      blockedAttemptsAt: '',
      company: 'ShopCorp',
      avatar: null,
      areaPermissions: [],
      permission: {
        id: 2,
        isEditable: false,
        title: 'עובד כללי',
        color: '#546D79',
        permissionDetaileds: [
          {
            id: 21,
            isArchitecture: false,
            isOrderable: true,
            isOrderEditable: false,
            isServiceable: true,
            isServiceEditable: false,
            isOrdersView: true,
            isServiceView: true,
            isDeliveryView: false,
            isAccounting: false,
          },
          {
            id: 22,
            isArchitecture: false,
            isOrderable: false,
            isOrderEditable: false,
            isServiceable: false,
            isServiceEditable: false,
            isOrdersView: false,
            isServiceView: false,
            isDeliveryView: false,
            isAccounting: false,
          },
        ],
      },
      isOwner: false,
      isPayCustomer: true,
      isNotPayedCustomer: false,
      isRegularCustomer: false,
      userFreeFields: [
        { id: 2, keyword: 'promoCode', valueword: 'WELCOME10' },
      ],
      minimumOrder: 100,
      isSendOrderDoc: true,
    },
    {
      id: 4,
      email: 'Ramiburshter@companyname.com',
      roles: 'guest',
      password: 'hashed_password_guest',
      isRegistered: false,
      name: 'רמי בורנשטיין',
      phone: '053-2717339',
      extId: 'guest-004',
      isBlocked: true,
      createdAt: '2025-03-15T07:00:00Z',
      recovery: 'recovery-token-004',
      updatedAt: '2025-03-16T12:00:00Z',
      attempts: 5,
      blockedAttemptsAt: '2025-03-16T12:15:00Z',
      company: '',
      avatar: null,
      areaPermissions: [],
      permission: {
        id: 2,
        isEditable: false,
        title: 'הנה"ח',
        color: '#1E676E',
        permissionDetaileds: [
          {
            id: 21,
            isArchitecture: false,
            isOrderable: true,
            isOrderEditable: false,
            isServiceable: true,
            isServiceEditable: false,
            isOrdersView: true,
            isServiceView: true,
            isDeliveryView: false,
            isAccounting: false,
          },
          {
            id: 22,
            isArchitecture: false,
            isOrderable: false,
            isOrderEditable: false,
            isServiceable: false,
            isServiceEditable: false,
            isOrdersView: false,
            isServiceView: false,
            isDeliveryView: false,
            isAccounting: false,
          },
        ],
      },
      isOwner: false,
      isPayCustomer: false,
      isNotPayedCustomer: true,
      isRegularCustomer: false,
      userFreeFields: [],
      minimumOrder: 0,
      isSendOrderDoc: false,
    },
  ];

const TourExample = () => {
    const [expanded, setExpanded] = useState(true);
    const [openModal, setOpenModal] = useState(false)
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Box id={'bussnies1'}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', mt:'20px', alignItems:'center' }} onClick={handleExpandClick}>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Typography color='#154D72' fontWeight={700} lineHeight={'21px'} fontSize={'15px'}>
                        עובדים בארגון {`(${data?.length})`}
                    </Typography>
                </Box>
                
                <Box>
                    {expanded &&
                        <IconButton
                            onClick={(e) => {setOpenModal(true); e.stopPropagation();}}
                        >
                            <AddCircleOutlineRoundedIcon sx={{color:'#154D72'}} />
                        </IconButton>
                    }        
                    <IconButton aria-expanded={expanded} aria-label="show more">
                        {expanded ? <ExpandLessIcon sx={{color:'#154D72'}}/> : <ExpandMoreIcon sx={{color:'#154D72'}}/>}
                    </IconButton>
                </Box>
            
            </Box>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                {data?.map((item, index) => (
                    <UserCard key={index} item={item} />
                ))}
            </Collapse>
            <CreateModal openModal={openModal} setOpenModal={setOpenModal}/>
        </Box>
    );
};

export default TourExample;